import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type SourceType from 'webapp/models-custom/source-type';

export default class MetricLibrarySourceRoute extends Route {
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;
	@service('navigation') declare navigationService: Service.Navigation;

	override model(params: { source_key: string }): SourceType | null | undefined {
		let model;

		if (params?.source_key) {
			model = this.mmSourceTypesService.findModelByKey(params.source_key);
		}

		if (!model) {
			this.navigationService.replaceRoute('metric-library.index');
		}

		return model;
	}
}
